import { firestore } from '../providers/Firebase';

export const root = firestore;
export const feedbackCollection = root.collection('feedbacks');
export const wordCollection = root.collection('words');
export const usersCollection = root.collection('users');
export const categoriesCollection = root.collection('categories');